import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const LoginMat = styled.div`
    width:400px;
    min-height:515px;
    margin-left:auto;
    margin-right:auto;    
    display:flex;
    flex-direction: column;
    justify-content: center;
`

export const LoginInner = styled.div`
    flex-grow: 1;
    margin: 1rem 0;
    background: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    border-radius:6px;
    padding:40px;
`;

export const FooterCreds = styled.p`
    color:${theme.colors.white};
    font-size:12px;
    text-align:center;
    font-weight:500;
    margin-bottom:0;
    font-family:"Poppins";
`